import { useAssignTrainingToTeam } from '../../../../lib/api/postApi';
import { TeamAssignTrainingDialogProps } from './TeamAssignedTrainings.types';
import AssignTrainingDialog from '../../base/AssignTrainingDialog/AssignTrainingDialog';
import { Api } from '../../../../lib/types/apiSpec';

const TeamAssignTrainingDialog = ({ teamId, ...rest }: TeamAssignTrainingDialogProps) => {
  const assignCourse = useAssignTrainingToTeam({ teamid: teamId, type: Api.TrainingType.Course });
  const assignLearningPath = useAssignTrainingToTeam({ teamid: teamId, type: Api.TrainingType.LearningPath });

  return (
    <AssignTrainingDialog
      assignCourse={assignCourse}
      assignLp={assignLearningPath}
      params={{ excludeAssignedToTeamId: teamId }}
      {...rest}
    />
  );
};

export default TeamAssignTrainingDialog;
